import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Flex, theme, Typography } from 'antd';

import { SPACE_LG, SPACE_MD } from '@/theme/buildAntdTheme';
import { hireportFontSizes } from '@/theme/fontSizes';

import type { ReactNode } from 'react';

type ErrorStateProps = {
  title: ReactNode;
  /** Optional custom illustration; defaults to a quiet error glyph. */
  icon?: ReactNode;
  /** Optional action, e.g. a reload or back-to-dashboard button. */
  action?: ReactNode;
  /** Terminal pages get a full-viewport, larger treatment. */
  fullPage?: boolean;
};

/** Shared error state (icon + title + action) for terminal pages and failed panels. */
const ErrorState = ({ title, icon, action, fullPage }: ErrorStateProps) => {
  const { token } = theme.useToken();

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={fullPage ? SPACE_LG : SPACE_MD}
      data-testid="error-state"
      style={
        fullPage
          ? { minHeight: '100vh', width: '100%' }
          : { padding: SPACE_LG, width: '100%' }
      }
    >
      {icon ?? (
        <ExclamationCircleOutlined
          style={{
            fontSize: fullPage
              ? hireportFontSizes.fontSize3xl * 2
              : hireportFontSizes.fontSize3xl,
            color: token.colorTextTertiary,
          }}
        />
      )}
      {fullPage ? (
        <Typography.Title
          level={3}
          type="secondary"
          style={{ textAlign: 'center' }}
        >
          {title}
        </Typography.Title>
      ) : (
        <Typography.Text type="secondary" style={{ textAlign: 'center' }}>
          {title}
        </Typography.Text>
      )}
      {action}
    </Flex>
  );
};

export default ErrorState;
